import React, {useRef} from 'react';

import {ActionButton} from "../../../misc/buttons/action-button";
import {Ellipsis} from "../../../misc/ellipsis/ellipsis";
import styles from "../../style/prediction.module.scss";
import classNames from "classnames";

export const PredictionOptionButton = ({option, onClick, animationRunning}) => {
  const ref = useRef()
  const buttonProps = {
    className: classNames(styles.option_button, {[styles.option_button_animation]: animationRunning}),
    onClick: () => onClick && onClick(option),
    ref
  }

  const textProps = {
    numOfMaxLines: 2,
    text: option.name,
    className: styles.option_button_text
  }

  return (
    <ActionButton {...buttonProps}>
      <Ellipsis {...textProps}/>
    </ActionButton>
  )
}
